export default "__VITE_ASSET__Dttz3M_m__"